// edjsHTML tranforms editor js blocks to html
import edjsHTML from 'editorjs-html'
// this function parses strings (html elements) to html
import parse from 'html-react-parser'

const edjsParser = edjsHTML()

export default function EditorTextParser({ data }: { data: any }) {
  // array of html elements
  const html = edjsParser.parse(data)

  return (
    <div className="text-container mt-14 pb-14">
      <article className="prose lg:prose-xl">{parse(html.join(''))}</article>
    </div>
  )
}
